import { render } from "./AdComponent.vue?vue&type=template&id=cb5eddf6&scoped=true"
import script from "./AdComponent.vue?vue&type=script&lang=js"
export * from "./AdComponent.vue?vue&type=script&lang=js"

import "./AdComponent.vue?vue&type=style&index=0&id=cb5eddf6&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5eddf6"]])

export default __exports__